import React from 'react';
import { Helmet } from 'react-helmet-async';

import * as ExternalRoutes from './external_routes';
import * as Routes from './routes';

export { ExternalRoutes };
export { Routes };

export function withTitle<P extends Record<string, unknown>>(
  title: string,
  Component: React.ComponentType<P>,
): React.ComponentType<P> {
  return function TitledComponent(props: P) {
    return (
      <>
        <Helmet title={title} />
        <Component {...props} />
      </>
    );
  };
}
